import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import { ImagePreview } from 'vant'

import './plugins/vant'
import './plugins/component'

Vue.use(ImagePreview);

import '@/styles/custom-vant.scss'
import '@/styles/custom.scss'

import './icons'
import './permission' // permission control

Vue.config.productionTip = false;
Vue.prototype.baseUrl = window.location.href;
Vue.prototype.isIOS = function () {
    let u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};

new Vue({
    router,
    store,
    render: h => h(App),
    async created() {
        if (!this.$store.getters.token) {
            let weixinId = this.$store.state.user.weixinId;
            let unionId = this.$store.state.user.unionId;
            if (weixinId) {
                // 现在改成传对象，同时带 unionId
                await this.$store.dispatch('user/autoLogin', {
                    weixinId: weixinId,
                    unionId: unionId
                })
            }
        }
        this.init()
    },
    methods: {
        init() {
            this.$mount('#app')
        }
    }
})
